import styled from "styled-components";

export const FigureInfomationWrapper = styled.div`
  text-align: center;
`;
